<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Estados">
    </nz-page-header>

    <nz-table #statusesTable nzTableLayout="auto" nzSize="small" [nzData]="statuses" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true">
        <thead>
            <tr>
                <th nzWidth="200px">Nombre</th>
                <th nzWidth="200px">Siguiente estado</th>
                <th nzWidth="200px">¿Estado de inicio?</th>
                <th nzWidth="200px">¿Estado de final?</th>
                <th nzWidth="200px">¿Estado de pausa?</th>
            </tr>
        </thead>
        <tbody>
            @for (data of statusesTable.data; track data) {
            <tr>
                <td class="text-center">
                    <span [ngClass]="data.cssClassName">{{ data.name }}</span>
                </td>
                <td class="text-center">
                    <span
                        [ngClass]="getNextStatus(data.nextStatus) ? getNextStatus(data.nextStatus)!.cssClassName : ''">{{getNextStatus(data.nextStatus)
                        ? getNextStatus(data.nextStatus)?.name : '-'}}</span>
                </td>
                <td>{{ data.isStartingStatus ? 'Sí' : 'No' }}</td>
                <td>{{ data.isEndingStatus ? 'Sí' : 'No' }}</td>
                <td>{{ data.isPauseStatus ? 'Sí' : 'No' }}</td>
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'500px'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Nombre
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique el nombre del estado">
                        <input onfocus="select()" nz-input placeholder="Indique el nombre del estado" type="text"
                            id="name" formControlName="name" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Abreviatura
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique la abreviatura del estado">
                        <input onfocus="select()" nz-input placeholder="Indique la abreviatura del estado" type="text"
                            id="abbreviation" formControlName="abbreviation" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-control>
                        <label nz-checkbox [nzDisabled]="fieldsReadOnly" id="isStartingStatus"
                            formControlName="isStartingStatus">¿Es un estado de comienzo?</label>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-control>
                        <label nz-checkbox [nzDisabled]="fieldsReadOnly" id="isPauseStatus"
                            formControlName="isPauseStatus">¿Es un estado de pausa?</label>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-control>
                        <label nz-checkbox [nzDisabled]="fieldsReadOnly" id="isEndingStatus"
                            formControlName="isEndingStatus">¿Es un estado de final?</label>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label>
                        Siguiente estado
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select nzShowSearch nzPlaceHolder="Seleccione el siguiente estado" id="nextStatus"
                            formControlName="nextStatus" [nzDisabled]="fieldsReadOnly || hasEndingOrPause()">
                            @for (p of statuses; track p.name) {
                            <nz-option [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>